import { RedefinirSenha } from "./RedefinirSenha";

export default RedefinirSenha;